import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/tech/output',
      name: 'techoutput',
      component: () => import('./views/Tech-output.vue')

    },
    {
      path: '/tech/map',
      name: 'mapoutput',
      component: () => import('./views/Map-output.vue')

    },
    {
      path: '/artists/:slug',
      name: 'artist',
      component: () => import('./views/Artist-detail.vue')
    },
    {
      path: '/:slug',
      name: 'page',
      component: () => import('./views/Page.vue')
    }
  ]
})
